/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.223.0-v202611042033-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * The Column Definitions for this Table Definition
 */
export interface ColumnDefinitionOutputV1 {
    /**
     * The column definition's name
     */
    "columnName": string;
    /**
     * 1-based index representing the position of the column in the table
     */
    "columnOrder"?: number;
    /**
     * The type of the column being defined
     */
    "columnType": ColumnTypeEnum;
    /**
     * The column definition's Unit of Measure
     */
    "columnUom"?: string;
    /**
     * The column definition's optional description
     */
    "description"?: string;
    /**
     * The column definition's optional display property
     */
    "displayProperty"?: string;
    /**
     * The column definition's ID
     */
    "id": string;
    /**
     * Whether the column is generated by Seeq rather than user created
     */
    "isGenerated": boolean;
    /**
     * Whether the column is hidden
     */
    "isHidden": boolean;
    /**
     * Whether the column is indexed
     */
    "isIndexed": boolean;
    /**
     * Whether the column contains only manually entered data from users. Null when unset.
     */
    "isManuallyEntered"?: boolean;
    /**
     * Optional unit-of-measure metadata for the resolved output type. Signal uses the Value Unit Of Measure key; Scalar uses the Unit Of Measure key. An absent UOM key indicates the Any-UOM opt-out; an empty-string value indicates the dimensionless unit.
     */
    "outputItemMetadata"?: { [key: string]: string; };
    /**
     * The resolved output item type for UUID columns (e.g., Signal, Scalar, Condition). Null when no type has been determined yet or the column has heterogeneous output types.
     */
    "outputItemType"?: string;
    /**
     * True when the output item type was explicitly declared by an author. False when it was automatically computed from materialization observations.
     */
    "outputItemTypeOverridden"?: boolean;
    /**
     * The rules associated with the column definition
     */
    "rules": Array<models.ColumnRuleOutputV1>;
    /**
     * Whether to sort ascending
     */
    "sortAscending": boolean;
    /**
     * The sort index for the column, null if not sorted
     */
    "sortIndex"?: number;
}

export const ColumnTypeEnum = {
    UUID: 'UUID',
    TEXT: 'TEXT',
    NUMERIC: 'NUMERIC',
    TIMESTAMPTZ: 'TIMESTAMPTZ',
    BOOLEAN: 'BOOLEAN'
} as const;

export type ColumnTypeEnum = typeof ColumnTypeEnum[keyof typeof ColumnTypeEnum];
